

$( document ).ready(function() {
  
  /* handles non discount checkout terms and conditions checnbox */
   $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  
  
  /* handles discount checkout (with terms and conditions checnbox) */
  
  $('#cff-discount-checkout').click(function(e) 
	{
    	if ($('#agree').is(':checked')) 
        {

          e.preventDefault()

          // cff_cust_id holds the customer id

          // get cart
          console.log("trigger");
          var url = "/cart.js";
          $.get(url, function( cff_cart ) {

              console.log(cff_cart);
              // send it to the server

            $.post("https://christiansfitnessfactory.com/shopify/shopify_discount_checkout.php?",
                   { cust_id: cff_cust_id, cart:cff_cart },
                   function( cff_redirect ) {

                  console.log(cff_redirect);

                  window.location = cff_redirect;		// comment for testing

              });	
          }, "json");	    
        }
    	else 
        {
          alert("You must agree with the terms and conditions of sales to check out.");
          return false;
        }
  	});
});

